import { isNative } from './platform'

/**
 * Verbindet das native Capacitor-Network-Plugin mit einem `setOffline`-Callback –
 * zuverlässiger als `navigator.onLine` auf Mobilgeräten. Auf dem Web ein No-op
 * (dort übernehmen die Browser-Online/Offline-Events in `usePwa`).
 *
 * @param {(offline: boolean) => void} setOffline - Callback, der bei Statuswechsel mit dem
 *   Offline-Zustand aufgerufen wird (initial sofort, danach bei jeder Änderung).
 * @returns {Promise<() => void>} Aufräumfunktion, die den Listener wieder entfernt.
 */
export async function initNativeNetwork (setOffline) {
  if (!isNative()) return () => {}
  try {
    const { Network } = await import('@capacitor/network')
    const status = await Network.getStatus()
    setOffline(!status.connected)
    const handle = await Network.addListener('networkStatusChange', s => setOffline(!s.connected))
    return () => handle.remove()
  } catch (_) {
    return () => {}
  }
}
